<template>
	<div>
		<b-row>
			<b-col cols="12" sm="12" md="12" lg="12" xl="12">
				<b-card v-if="assessment.candidate" border-variant="primary" header="Candidate" header-bg-variant="default" class="mt-3">
					<b-card-text>
						<b-row>
              <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-2"><b>Name</b> {{ assessment.candidate.name }} {{ assessment.candidate.surname }}</b-col>
							<b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>Mobile Phone</b> {{ assessment.candidate.phoneMobileDDI }} {{ assessment.candidate.phoneMobile }}</b-col>
							<b-col v-if="assessment.candidate.phoneWork" cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>Work Phone</b> {{ assessment.candidate.phoneWorkDDI }} {{ assessment.candidate.phoneWork }}</b-col>
							<b-col v-if="assessment.candidate.phonePrivate" cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>Private Phone</b> {{ assessment.candidate.phonePrivateDDI }} {{ assessment.candidate.phonePrivate }}</b-col>
							<b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>Gender Identity</b> {{ assessment.candidate.gender.name }}</b-col>
							<b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>E-mail</b> {{ assessment.candidate.email }}</b-col>
							<b-col v-if="assessment.candidate.cpf" cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>CPF</b> {{ assessment.candidate.cpf }}</b-col>
							<b-col cols="12" sm="6" md="6" lg="6" xl="6" class="mb-2"><b>Birthday Date</b> {{ assessment.candidate.birthPlace | formatDate }} (Age: {{ assessment.candidate.birthPlace | formatAge }})</b-col>
							<b-col v-if="assessment.candidate.currentNationality" cols="12" sm="6" md="6" lg="6" xl="6"><b>Nationality</b> {{ assessment.candidate.currentNationality.name }}</b-col>
							<b-col cols="12" sm="6" md="6" lg="6" xl="6"><b>Marital Status</b> {{ assessment.candidate.civilState.name }}</b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="assessment.curriculum" border-variant="primary" header="Assessment" header-bg-variant="default">
					<b-card-text>
						<b-row>
              <b-col v-if="assessment.assessmentStatus" xs="12" sm="4" md="4" lg="4" xl="4" class="mb-2"><b>Status</b> {{ assessment.assessmentStatus.description }}</b-col>
							<b-col v-if="assessment.curriculum" xs="12" sm="4" md="4" lg="4" xl="4" class="mb-2"><b>CV</b> {{ assessment.curriculum.sequenceId }} - {{ assessment.curriculum.agency.name }}</b-col>
							<b-col xs="12" sm="4" md="4" lg="4" xl="4" class="mb-2"><b>Confidential</b> {{ assessment.confidential | formatYesNo }}</b-col>
						</b-row>
            <b-row v-if="assessment.description" class="pt-2">
							<b-col cols="12" sm="12" md="12" lg="12" xl="12" class="mb-2"><b>Description</b></b-col>
              <b-col style="background-color: rgb(242, 242, 242, 0.3)" cols="12" sm="12" md="12" lg="12" xl="12" class="mb-2"><pre>{{ assessment.description }}</pre></b-col>
						</b-row>
					</b-card-text>
				</b-card>
				<b-card v-if="assessment.assessmentFile && assessment.assessmentFile.length > 0" border-variant="primary" header="Files" header-bg-variant="default">
					<b-card-text>
						<b-row>
							<b-table hover :items="assessment.assessmentFile" :fields="fileFields">
                <template v-slot:cell(name)="row">
                  {{ row.item.file.name }}
                </template>
                <template v-slot:cell(description)="row">
                  {{ row.item.file.description }}
                </template>
                <template v-slot:cell(Options)="row">
                  <b-button v-b-tooltip.hover title="Download" variant="success" size="xs" @click="downloadFile(row.item.file)"><i class="fas fa-download"></i></b-button>
                </template>
              </b-table>
						</b-row>
					</b-card-text>
				</b-card>
			</b-col>
		</b-row>
    <div v-if="assessment.updatedBy" class="row">
      <div class="col-md-12 text-center">
        Modified by <b>{{ assessment.updatedBy.name }} {{ assessment.updatedBy.surname }}</b> at {{ assessment.updatedAt | formatDateTime }}.
      </div>
    </div>
	</div>
</template>

<script>
import { authComputed } from '@state/helpers'
import appConfig from '@src/app.config'
import axios from 'axios'

export default {
  props: {
    id: { 
      type: String, 
      required: true,
      default: ''
    }
  },
  data() {
    return {
      assessment: {},
      fileFields: [
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'description',
          label: 'Description'
        },
        {
          key: 'Options',
          label: 'Options',
          thStyle: { 'word-wrap': 'break-word' },
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ]
		}
  },
  computed: {
    ...authComputed,
  },
  created () {
    this.loadAssessment()
  },
  methods: {
    loadAssessment () {
      this.isLoading = true
      axios.get(appConfig.apiUrl + `assessment/${this.id}`,
      { headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } })
      .then((response) => {
        this.assessment = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    },
    downloadFile (item) {
      this.isLoading = true
      axios.get(appConfig.apiUrl + `assessment-file/download/${item.id}`,
      { 
        headers: { 'Authorization': `Bearer ${this.currentUser.access_token}`, 'content-type': 'application/x-www-form-urlencoded' },
        responseType: 'blob'
      })
      .then((response) => {
        if(response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.originalName);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      })
      .finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>